(() => {
  const roots = document.querySelectorAll('[data-icon-text-marquee]');
  if (!roots.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const update = (root) => {
    const viewport = root.querySelector('.icon-text-marquee__viewport');
    const list = root.querySelector('.icon-text-marquee__list:not([aria-hidden="true"])');
    if (!viewport || !list) return;

    /* Measure primary list only (duplicate may be display:none when idle) */
    root.classList.toggle('is-scrolling', list.scrollWidth > viewport.clientWidth + 1);
  };

  roots.forEach((root) => {
    update(root);
    /* Re-check after icons load — late width change used to leave a wrong mode */
    root.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', () => update(root), { once: true });
    });
    if (window.ResizeObserver) {
      new ResizeObserver(() => update(root)).observe(root);
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-icon-text-marquee]').forEach(update);
  });
})();
